import React from "react";
import { useDispatch } from "react-redux";
import { Formik, Field, Form } from "formik";
import { useTranslation } from "react-i18next";
import { onAmeriabankAccountSave } from "../../../store/Settings/actions";

export const AmeriabankPayment = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleSubmit = (values, {resetForm})=>{
        dispatch(onAmeriabankAccountSave(values));
        resetForm()
    }

    return (
        <div className="grid grid-cols-7 mb-5">
            <div className="col-start-1 col-end-4 bg-white p-5 mr-4">
                <p className="font-bold text-xl mb-1"> Ameriabank {t("Payment solution")}</p>
                <p className="font-medium text-sm">
                    {t(
                        "Please create an account by selecting Ameriabank below to receive customer payments. With your Ameriabank account you will be able to login into your Ameriabank dashboard and manage customer payments. Learn more about Ameriabank in the Payments section of the Cheqit Help Centre."
                    )}
                </p>
            </div>
            <div className="col-start-4 col-end-8 rounded-lg shadow-md bg-white p-5">                
                <Formik
                    enableReinitialize
                    initialValues={{account_number: ""}}
                    onSubmit={async (values, {resetForm}) => {handleSubmit(values, {resetForm})}}
                >
                    <Form>
                        <div className="w-4/5 mb-4">
                            <div className="col-span-3 sm:col-span-3 py-3.5">
                                <label
                                    htmlFor="account_number"
                                    className="block text-sm font-semibold mb-2"
                                >
                                    {t("Account number")}
                                </label>
                                <Field
                                    type="text"
                                    name="account_number"
                                    className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                />
                            </div>
                        </div>
                        <div className="text-right">
                            <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                            >
                                {t("Save")}
                            </button>
                        </div>
                    </Form>
                </Formik>
            </div>
        </div>
    );
};
